import React, { useState, useEffect } from "react"
import TitleStyled from "./styles/titleStyles"
import HiddenInfoStyled from "./styles/HiddenInfoStyles"

const HiddenInfo = ({ heading, description, showHideInfo, color }) => {
  const [activeTab, setActiveTab] = useState(0)

  return (
    <HiddenInfoStyled color={color}>
      <div className="container">
        <TitleStyled textAlign="center" linePosition="center" color="#000">
          <h2 dangerouslySetInnerHTML={{ __html: heading }}></h2>
        </TitleStyled>
        <div className="container--small">
          <p
            className="descirption--small"
            dangerouslySetInnerHTML={{ __html: description }}
          ></p>
        </div>
        <div className="hiddenInfo__wrapper">
          {showHideInfo.map((item, index) => (
            <div
              className={`hiddenInfo__item ${
                activeTab === index ? "hiddenInfo__item--active" : ""
              }`}
              key={"hiddenInfo_" + index}
            >
              <p
                className="hiddenInfo__item__heading"
                style={{
                  color: activeTab === index ? item.value.colorHeading : "",
                }}
                onClick={() => {
                  setActiveTab(index)
                }}
              >
                <span>{item.value.heading}</span>
              </p>
              <p
                style={{
                  maxHeight: activeTab === index ? 230 + "px" : "",
                }}
                className="hiddenInfo__item__description"
                dangerouslySetInnerHTML={{ __html: item.value.descirption }}
              ></p>
            </div>
          ))}
        </div>
      </div>
    </HiddenInfoStyled>
  )
}

export default HiddenInfo
